import { css } from '@emotion/react';
import styled from '@emotion/styled';

import {
    ListingTag,
    ListingTagsContainer
} from '../ListingTags/ListingTags.styles';
import { ListingCountList } from './ListingCounts/ListingCounts.styles';
import { ListingImageContainer } from './ListingImagePreview/ListingImagePreview.styles';

export const ListingPreviewContainer = styled('div')(
    ({ theme: { spacing } }) => css`
        ${ListingImageContainer} {
            margin-bottom: ${spacing['24px']};
        }
    `
);

export const ListingPreviewLink = styled('a')(
    ({ theme: { focusRing, spacing } }) => css`
        display: block;
        text-decoration: none;
        :focus {
            box-shadow: ${focusRing};
            outline: 0;
        }

        ${ListingCountList} {
            margin-top: ${spacing['16px']};
        }
    `
);

export const ListingPriceContainer = styled('div')(
    ({ theme: { spacing, mq } }) => css`
        align-items: center;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: ${spacing['16px']};

        ${mq.extraLarge} {
            justify-content: flex-start;
        }

        ${ListingTagsContainer} {
            margin-left: ${spacing['16px']};
            margin-right: 0;
            margin-top: 0;

            ${ListingTag} {
                margin-bottom: 0;
            }
        }
    `
);

export const ListingAddress = styled('address')(
    ({ theme: { colors, fontSizes, spacing } }) => css`
        color: ${colors['neutral-6']};
        font-size: ${fontSizes['8']};
        font-style: normal;
        margin: ${spacing['8px']} 0 0;
    `
);

export const ListingPreviewBranchLink = styled('a')(
    ({ theme: { focusRing, spacing } }) => css`
        align-items: flex-start;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin-top: ${spacing['48px']};
        text-decoration: none;
        :focus {
            box-shadow: ${focusRing};
            outline: 0;
        }
    `
);

export const BranchDetails = styled('div')(
    ({ theme: { spacing } }) => css`
        flex: 1 1 100%;
        margin-right: ${spacing['24px']};
    `
);

export const BranchAddress = styled('address')(
    ({ theme: { colors, spacing } }) => css`
        color: ${colors['neutral-6']};
        font-style: normal;
        margin: ${spacing['8px']} 0 0;
    `
);

export const BranchImg = styled('img')(
    () => css`
        display: block;
        height: auto;
        max-width: 8.75rem; /* 140px */
    `
);
